import { createSearchParams } from 'react-router-dom';

const getPageSize = (col: number, row: number) => {
    const width = window.innerWidth;
    switch (true) {
        case width < 1280:
            return (col - 1) * (row - 1);
        case 1280 >= width || width < 1536:
            return col * row;
        default:
            return (col + 1) * (row + 1);
    }
};

const getPageNumber = (search: string) => {
    const searchParams = createSearchParams(search).get('page');
    return searchParams == null ? 1 : parseFloat(searchParams);
};

export { getPageSize, getPageNumber };
